import React from "react";
import Footer from "../common/Footer";
import ReceptionistHeader from "../common/ReceptionistHeader";

const ReceptionistDashboard = () => {
  return (
    <>
      <ReceptionistHeader />
      <div className="container mt-5">
        <div>Reception Dashboard</div>
      </div>
      <Footer />
    </>
  );
}

export default ReceptionistDashboard;
